const messages = {
  title: "Errore interno",
  description: "I dati di questa pagina non possono essere caricati correttamente.",
  backHomeButton: "Torna alla dashboard"
}

export default {
  messages
}
